import { render, staticRenderFns } from "./setoresEditar.vue?vue&type=template&id=c8605d8c&scoped=true&"
import script from "./setoresEditar.vue?vue&type=script&lang=js&"
export * from "./setoresEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8605d8c",
  null
  
)

export default component.exports